import { render, staticRenderFns } from "./ExternalSyncPage.vue?vue&type=template&id=7f97aee1"
import script from "./ExternalSyncPage.vue?vue&type=script&lang=js"
export * from "./ExternalSyncPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports